import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import MODULE_ICONS from "../../../../data/moduleIcons";
import { ArrowDownIcon } from "../../../Icons";
import { LogIEIconSmall } from "../../../Icons/Header-Icons";
import { StyledModuleIcon } from "./Modules-styled";

const ModuleIcon = ({
  module,
  showTitle = false,
  children,
  showArrow = true,
  total,
  ...props
}) => {
  const { t } = useTranslation("common");
  const icon = useMemo(() => {
    if (module) {
      return MODULE_ICONS[module] ?? MODULE_ICONS.default;
    } else {
      return <LogIEIconSmall width="24" height="24" />;
    }
  }, [module]);

  return (
    <StyledModuleIcon {...props}>
      {icon}
      {showTitle && (
        <span>
          {t("screen.widget.ModuleSwitcher." + module + ".name", "")}
          {showArrow && <ArrowDownIcon fill="white" />}
          {children}
        </span>
      )}
    </StyledModuleIcon>
  );
};

export default ModuleIcon;
